// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RollUpOverviewTotalsPPTX from './RollUpOverviewTotalsPPTX';
import RollUpOverviewAreaPPTX from './RollUpOverviewAreaPPTX';
// css
import '../../../styles/components/analytics/pptx/RollUpOverviewPPTX.scss';


class RollUpOverviewPPTX extends Component {

  getAreaSlice() {
    const { activeAreasWithSubAreasWithSourcesStats, pageIndex } = this.props;
    const areas = activeAreasWithSubAreasWithSourcesStats;
    const mid = Math.floor(areas.length / 2);
    return pageIndex === 1 ? areas.slice(mid) : areas.slice(0, mid);
  }

  renderAreas() {
    const { abilities } = this.props;

    return this.getAreaSlice().map((area, index) => (
      <RollUpOverviewAreaPPTX
        key={index}
        area={area}
        subAreas={area.subAreas}
        showPercentIndexed={abilities.canViewTotalIndexed}
      />
    ));
  }

  render() {
    const { pptxTarget, totalStats, abilities, pageIndex } = this.props;

    return (
      <div className='analytics__roll-up-overview-pptx' id={pptxTarget}>
        {pageIndex === 0 &&
          <RollUpOverviewTotalsPPTX
            configuredItems={totalStats.configuredItems}
            dataRequired={totalStats.dataRequired}
            percentIndexed={totalStats.percentIndexed}
            dataIndexed={totalStats.dataIndexed}
            ciscoDataPerDay={totalStats.ciscoDataPerDay}
            nonCiscoDataPerDay={totalStats.nonCiscoDataPerDay}
            ciscoDataIndexed={totalStats.ciscoDataIndexed}
            nonCiscoDataIndexed={totalStats.nonCiscoDataIndexed}
            ciscoPercentIndexed={totalStats.ciscoPercentIndexed}
            nonCiscoPercentIndexed={totalStats.nonCiscoPercentIndexed}
            showPercentIndexed={abilities.canViewTotalIndexed}
            peakBuffer={totalStats.peakBuffer}
            environmentDataPerDay={totalStats.environmentDataPerDay}
          />
        }
        {this.renderAreas()}
      </div>
    );
  }
}

RollUpOverviewPPTX.defaultProps = {
  pageIndex: 0
};

RollUpOverviewPPTX.propTypes = {
  activeAreasWithSubAreasWithSourcesStats: PropTypes.array.isRequired,
  pptxTarget: PropTypes.string.isRequired,
  totalStats: PropTypes.object.isRequired,
  abilities: PropTypes.object.isRequired,
  pageIndex: PropTypes.number
};

export default RollUpOverviewPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/RollUpOverviewPPTX.js